import { useGet } from '@ngt/forms';
import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';
import { PropertyGetAsCollection, PropertyGetAsCollectionResponse } from '../../api/dtos';

const getData = (response?: SWRResponse<PropertyGetAsCollectionResponse, PropertyGetAsCollectionResponse>) => {
    return response?.data?.properties
}
const getError = (response?: SWRResponse<PropertyGetAsCollectionResponse, PropertyGetAsCollectionResponse>) => (response?.error ?? response?.data)?.responseStatus;
// const getAdditionalState = (response?: SWRResponse<ContractGetCollectionByLotIdResponse, ContractGetCollectionByLotIdResponse>) => ({});

const useProperties = (configuration?: SWRConfiguration<PropertyGetAsCollectionResponse, PropertyGetAsCollectionResponse>) => {
    
    const request = useMemo(() => {
        return () => {
            return new PropertyGetAsCollection();
        };
    }, [])

    return useGet(request, { getData, getError }, configuration);
}

export default useProperties;